export default function Logo() {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-20 md:w-32 h-10 md:h-16"
      width="378"
      height="178"
      viewBox="0 0 378 178"
      fill="none"
    >
      <g filter="url(#filter0_d_1394_456)">
        <mask
          id="path-1-outside-1_1394_456"
          maskUnits="userSpaceOnUse"
          x="5"
          y="62"
          width="86"
          height="85"
          fill="black"
        >
          <rect fill="white" x="5" y="62" width="86" height="85" />
          <path d="M7.55186 144.362V74.6619H18.4463V64.015H34.1691V74.6619H45.1873V95.8318H51.2536V74.6619H62.2719V64.015H78.1184V74.6619H88.8891V144.362H73.2902V80.9757H67.1001V102.022H56.0818V133.839H40.3591V102.022H29.3408V80.9757H23.2746V144.362H7.55186Z" />
        </mask>
        <path
          d="M7.55186 144.362V74.6619H18.4463V64.015H34.1691V74.6619H45.1873V95.8318H51.2536V74.6619H62.2719V64.015H78.1184V74.6619H88.8891V144.362H73.2902V80.9757H67.1001V102.022H56.0818V133.839H40.3591V102.022H29.3408V80.9757H23.2746V144.362H7.55186Z"
          fill="#96FF43"
        />
        <path
          d="M7.55186 144.362H5.55186V146.362H7.55186V144.362ZM7.55186 74.6619V72.6619H5.55186V74.6619H7.55186ZM18.4463 74.6619V76.6619H20.4463V74.6619H18.4463ZM18.4463 64.015V62.015H16.4463V64.015H18.4463ZM34.1691 64.015H36.1691V62.015H34.1691V64.015ZM34.1691 74.6619H32.1691V76.6619H34.1691V74.6619ZM45.1873 74.6619H47.1873V72.6619H45.1873V74.6619ZM45.1873 95.8318H43.1873V97.8318H45.1873V95.8318ZM51.2536 95.8318V97.8318H53.2536V95.8318H51.2536ZM51.2536 74.6619V72.6619H49.2536V74.6619H51.2536ZM62.2719 74.6619V76.6619H64.2719V74.6619H62.2719ZM62.2719 64.015V62.015H60.2719V64.015H62.2719ZM78.1184 64.015H80.1184V62.015H78.1184V64.015ZM78.1184 74.6619H76.1184V76.6619H78.1184V74.6619ZM88.8891 74.6619H90.8891V72.6619H88.8891V74.6619ZM88.8891 144.362V146.362H90.8891V144.362H88.8891ZM73.2902 144.362H71.2902V146.362H73.2902V144.362ZM73.2902 80.9757H75.2902V78.9757H73.2902V80.9757ZM67.1001 80.9757V78.9757H65.1001V80.9757H67.1001ZM67.1001 102.022V104.022H69.1001V102.022H67.1001ZM56.0818 102.022V100.022H54.0818V102.022H56.0818ZM56.0818 133.839V135.839H58.0818V133.839H56.0818ZM40.3591 133.839H38.3591V135.839H40.3591V133.839ZM40.3591 102.022H42.3591V100.022H40.3591V102.022ZM29.3408 102.022H27.3408V104.022H29.3408V102.022ZM29.3408 80.9757H31.3408V78.9757H29.3408V80.9757ZM23.2746 80.9757V78.9757H21.2746V80.9757H23.2746ZM23.2746 144.362V146.362H25.2746V144.362H23.2746ZM7.55186 144.362H9.55186V74.6619H7.55186H5.55186V144.362H7.55186ZM7.55186 74.6619V76.6619H18.4463V74.6619V72.6619H7.55186V74.6619ZM18.4463 74.6619H20.4463V64.015H18.4463H16.4463V74.6619H18.4463ZM18.4463 64.015V66.015H34.1691V64.015V62.015H18.4463V64.015ZM34.1691 64.015H32.1691V74.6619H34.1691H36.1691V64.015H34.1691ZM34.1691 74.6619V76.6619H45.1873V74.6619V72.6619H34.1691V74.6619ZM45.1873 74.6619H43.1873V95.8318H45.1873H47.1873V74.6619H45.1873ZM45.1873 95.8318V97.8318H51.2536V95.8318V93.8318H45.1873V95.8318ZM51.2536 95.8318H53.2536V74.6619H51.2536H49.2536V95.8318H51.2536ZM51.2536 74.6619V76.6619H62.2719V74.6619V72.6619H51.2536V74.6619ZM62.2719 74.6619H64.2719V64.015H62.2719H60.2719V74.6619H62.2719ZM62.2719 64.015V66.015H78.1184V64.015V62.015H62.2719V64.015ZM78.1184 64.015H76.1184V74.6619H78.1184H80.1184V64.015H78.1184ZM78.1184 74.6619V76.6619H88.8891V74.6619V72.6619H78.1184V74.6619ZM88.8891 74.6619H86.8891V144.362H88.8891H90.8891V74.6619H88.8891ZM88.8891 144.362V142.362H73.2902V144.362V146.362H88.8891V144.362ZM73.2902 144.362H75.2902V80.9757H73.2902H71.2902V144.362H73.2902ZM73.2902 80.9757V78.9757H67.1001V80.9757V82.9757H73.2902V80.9757ZM67.1001 80.9757H65.1001V102.022H67.1001H69.1001V80.9757H67.1001ZM67.1001 102.022V100.022H56.0818V102.022V104.022H67.1001V102.022ZM56.0818 102.022H54.0818V133.839H56.0818H58.0818V102.022H56.0818ZM56.0818 133.839V131.839H40.3591V133.839V135.839H56.0818V133.839ZM40.3591 133.839H42.3591V102.022H40.3591H38.3591V133.839H40.3591ZM40.3591 102.022V100.022H29.3408V102.022V104.022H40.3591V102.022ZM29.3408 102.022H31.3408V80.9757H29.3408H27.3408V102.022H29.3408ZM29.3408 80.9757V78.9757H23.2746V80.9757V82.9757H29.3408V80.9757ZM23.2746 80.9757H21.2746V144.362H23.2746H25.2746V80.9757H23.2746ZM23.2746 144.362V142.362H7.55186V144.362V146.362H23.2746V144.362Z"
          fill="black"
          mask="url(#path-1-outside-1_1394_456)"
        />
      </g>
      <g filter="url(#filter1_d_1394_456)">
        <mask
          id="path-3-outside-2_1394_456"
          maskUnits="userSpaceOnUse"
          x="101"
          y="61"
          width="57"
          height="75"
          fill="black"
        >
          <rect fill="white" x="101" y="61" width="57" height="75" />
          <path d="M112.954 133.178V124.077H103.531V72.8968H112.954V63.6886H145.503V72.8968H155.033V87.4584H141.327V78.3574H117.129V91.2059H136.081V105.661H117.129V118.616H141.327V109.408H155.033V124.077H145.503V133.178H112.954Z" />
        </mask>
        <path
          d="M112.954 133.178V124.077H103.531V72.8968H112.954V63.6886H145.503V72.8968H155.033V87.4584H141.327V78.3574H117.129V91.2059H136.081V105.661H117.129V118.616H141.327V109.408H155.033V124.077H145.503V133.178H112.954Z"
          fill="#96FF43"
        />
        <path
          d="M112.954 133.178H110.954V135.178H112.954V133.178ZM112.954 124.077H114.954V122.077H112.954V124.077ZM103.531 124.077H101.531V126.077H103.531V124.077ZM103.531 72.8968V70.8968H101.531V72.8968H103.531ZM112.954 72.8968V74.8968H114.954V72.8968H112.954ZM112.954 63.6886V61.6886H110.954V63.6886H112.954ZM145.503 63.6886H147.503V61.6886H145.503V63.6886ZM145.503 72.8968H143.503V74.8968H145.503V72.8968ZM155.033 72.8968H157.033V70.8968H155.033V72.8968ZM155.033 87.4584V89.4584H157.033V87.4584H155.033ZM141.327 87.4584H139.327V89.4584H141.327V87.4584ZM141.327 78.3574H143.327V76.3574H141.327V78.3574ZM117.129 78.3574V76.3574H115.129V78.3574H117.129ZM117.129 91.2059H115.129V93.2059H117.129V91.2059ZM136.081 91.2059H138.081V89.2059H136.081V91.2059ZM136.081 105.661V107.661H138.081V105.661H136.081ZM117.129 105.661V103.661H115.129V105.661H117.129ZM117.129 118.616H115.129V120.616H117.129V118.616ZM141.327 118.616V120.616H143.327V118.616H141.327ZM141.327 109.408V107.408H139.327V109.408H141.327ZM155.033 109.408H157.033V107.408H155.033V109.408ZM155.033 124.077V126.077H157.033V124.077H155.033ZM145.503 124.077V122.077H143.503V124.077H145.503ZM145.503 133.178V135.178H147.503V133.178H145.503ZM112.954 133.178H114.954V124.077H112.954H110.954V133.178H112.954ZM112.954 124.077V122.077H103.531V124.077V126.077H112.954V124.077ZM103.531 124.077H105.531V72.8968H103.531H101.531V124.077H103.531ZM103.531 72.8968V74.8968H112.954V72.8968V70.8968H103.531V72.8968ZM112.954 72.8968H114.954V63.6886H112.954H110.954V72.8968H112.954ZM112.954 63.6886V65.6886H145.503V63.6886V61.6886H112.954V63.6886ZM145.503 63.6886H143.503V72.8968H145.503H147.503V63.6886H145.503ZM145.503 72.8968V74.8968H155.033V72.8968V70.8968H145.503V72.8968ZM155.033 72.8968H153.033V87.4584H155.033H157.033V72.8968H155.033ZM155.033 87.4584V85.4584H141.327V87.4584V89.4584H155.033V87.4584ZM141.327 87.4584H143.327V78.3574H141.327H139.327V87.4584H141.327ZM141.327 78.3574V76.3574H117.129V78.3574V80.3574H141.327V78.3574ZM117.129 78.3574H115.129V91.2059H117.129H119.129V78.3574H117.129ZM117.129 91.2059V93.2059H136.081V91.2059V89.2059H117.129V91.2059ZM136.081 91.2059H134.081V105.661H136.081H138.081V91.2059H136.081ZM136.081 105.661V103.661H117.129V105.661V107.661H136.081V105.661ZM117.129 105.661H115.129V118.616H117.129H119.129V105.661H117.129ZM117.129 118.616V120.616H141.327V118.616V116.616H117.129V118.616ZM141.327 118.616H143.327V109.408H141.327H139.327V118.616H141.327ZM141.327 109.408V111.408H155.033V109.408V107.408H141.327V109.408ZM155.033 109.408H153.033V124.077H155.033H157.033V109.408H155.033ZM155.033 124.077V122.077H145.503V124.077V126.077H155.033V124.077ZM145.503 124.077H143.503V133.178H145.503H147.503V124.077H145.503ZM145.503 133.178V131.178H112.954V133.178V135.178H145.503V133.178Z"
          fill="black"
          mask="url(#path-3-outside-2_1394_456)"
        />
      </g>
      <g filter="url(#filter2_d_1394_456)">
        <mask
          id="path-5-outside-3_1394_456"
          maskUnits="userSpaceOnUse"
          x="165"
          y="62"
          width="69"
          height="68"
          fill="black"
        >
          <rect fill="white" x="165" y="62" width="69" height="68" />
          <path d="M167.919 127.067V72.4377H176.458V64.0928H188.781V72.4377H197.417V89.0304H202.172V72.4377H210.808V64.0928H223.228V72.4377H231.67V127.067H219.444V77.3864H214.592V93.882H205.956V118.82H193.633V93.882H184.997V77.3864H180.242V127.067H167.919Z" />
        </mask>
        <path
          d="M167.919 127.067V72.4377H176.458V64.0928H188.781V72.4377H197.417V89.0304H202.172V72.4377H210.808V64.0928H223.228V72.4377H231.67V127.067H219.444V77.3864H214.592V93.882H205.956V118.82H193.633V93.882H184.997V77.3864H180.242V127.067H167.919Z"
          fill="#96FF43"
        />
        <path
          d="M167.919 127.067H165.919V129.067H167.919V127.067ZM167.919 72.4377V70.4377H165.919V72.4377H167.919ZM176.458 72.4377V74.4377H178.458V72.4377H176.458ZM176.458 64.0928V62.0928H174.458V64.0928H176.458ZM188.781 64.0928H190.781V62.0928H188.781V64.0928ZM188.781 72.4377H186.781V74.4377H188.781V72.4377ZM197.417 72.4377H199.417V70.4377H197.417V72.4377ZM197.417 89.0304H195.417V91.0304H197.417V89.0304ZM202.172 89.0304V91.0304H204.172V89.0304H202.172ZM202.172 72.4377V70.4377H200.172V72.4377H202.172ZM210.808 72.4377V74.4377H212.808V72.4377H210.808ZM210.808 64.0928V62.0928H208.808V64.0928H210.808ZM223.228 64.0928H225.228V62.0928H223.228V64.0928ZM223.228 72.4377H221.228V74.4377H223.228V72.4377ZM231.67 72.4377H233.67V70.4377H231.67V72.4377ZM231.67 127.067V129.067H233.67V127.067H231.67ZM219.444 127.067H217.444V129.067H219.444V127.067ZM219.444 77.3864H221.444V75.3864H219.444V77.3864ZM214.592 77.3864V75.3864H212.592V77.3864H214.592ZM214.592 93.882V95.882H216.592V93.882H214.592ZM205.956 93.882V91.882H203.956V93.882H205.956ZM205.956 118.82V120.82H207.956V118.82H205.956ZM193.633 118.82H191.633V120.82H193.633V118.82ZM193.633 93.882H195.633V91.882H193.633V93.882ZM184.997 93.882H182.997V95.882H184.997V93.882ZM184.997 77.3864H186.997V75.3864H184.997V77.3864ZM180.242 77.3864V75.3864H178.242V77.3864H180.242ZM180.242 127.067V129.067H182.242V127.067H180.242ZM167.919 127.067H169.919V72.4377H167.919H165.919V127.067H167.919ZM167.919 72.4377V74.4377H176.458V72.4377V70.4377H167.919V72.4377ZM176.458 72.4377H178.458V64.0928H176.458H174.458V72.4377H176.458ZM176.458 64.0928V66.0928H188.781V64.0928V62.0928H176.458V64.0928ZM188.781 64.0928H186.781V72.4377H188.781H190.781V64.0928H188.781ZM188.781 72.4377V74.4377H197.417V72.4377V70.4377H188.781V72.4377ZM197.417 72.4377H195.417V89.0304H197.417H199.417V72.4377H197.417ZM197.417 89.0304V91.0304H202.172V89.0304V87.0304H197.417V89.0304ZM202.172 89.0304H204.172V72.4377H202.172H200.172V89.0304H202.172ZM202.172 72.4377V74.4377H210.808V72.4377V70.4377H202.172V72.4377ZM210.808 72.4377H212.808V64.0928H210.808H208.808V72.4377H210.808ZM210.808 64.0928V66.0928H223.228V64.0928V62.0928H210.808V64.0928ZM223.228 64.0928H221.228V72.4377H223.228H225.228V64.0928H223.228ZM223.228 72.4377V74.4377H231.67V72.4377V70.4377H223.228V72.4377ZM231.67 72.4377H229.67V127.067H231.67H233.67V72.4377H231.67ZM231.67 127.067V125.067H219.444V127.067V129.067H231.67V127.067ZM219.444 127.067H221.444V77.3864H219.444H217.444V127.067H219.444ZM219.444 77.3864V75.3864H214.592V77.3864V79.3864H219.444V77.3864ZM214.592 77.3864H212.592V93.882H214.592H216.592V77.3864H214.592ZM214.592 93.882V91.882H205.956V93.882V95.882H214.592V93.882ZM205.956 93.882H203.956V118.82H205.956H207.956V93.882H205.956ZM205.956 118.82V116.82H193.633V118.82V120.82H205.956V118.82ZM193.633 118.82H195.633V93.882H193.633H191.633V118.82H193.633ZM193.633 93.882V91.882H184.997V93.882V95.882H193.633V93.882ZM184.997 93.882H186.997V77.3864H184.997H182.997V93.882H184.997ZM184.997 77.3864V75.3864H180.242V77.3864V79.3864H184.997V77.3864ZM180.242 77.3864H178.242V127.067H180.242H182.242V77.3864H180.242ZM180.242 127.067V125.067H167.919V127.067V129.067H180.242V127.067Z"
          fill="black"
          mask="url(#path-5-outside-3_1394_456)"
        />
      </g>
      <g filter="url(#filter3_d_1394_456)">
        <mask
          id="path-7-outside-4_1394_456"
          maskUnits="userSpaceOnUse"
          x="242"
          y="61"
          width="57"
          height="75"
          fill="black"
        >
          <rect fill="white" x="242" y="61" width="57" height="75" />
          <path d="M253.954 133.178V124.077H244.531V72.8968H253.954V63.6886H286.503V72.8968H296.033V87.4584H282.327V78.3574H258.129V91.2059H277.081V105.661H258.129V118.616H282.327V109.408H296.033V124.077H286.503V133.178H253.954Z" />
        </mask>
        <path
          d="M253.954 133.178V124.077H244.531V72.8968H253.954V63.6886H286.503V72.8968H296.033V87.4584H282.327V78.3574H258.129V91.2059H277.081V105.661H258.129V118.616H282.327V109.408H296.033V124.077H286.503V133.178H253.954Z"
          fill="#96FF43"
        />
        <path
          d="M253.954 133.178H251.954V135.178H253.954V133.178ZM253.954 124.077H255.954V122.077H253.954V124.077ZM244.531 124.077H242.531V126.077H244.531V124.077ZM244.531 72.8968V70.8968H242.531V72.8968H244.531ZM253.954 72.8968V74.8968H255.954V72.8968H253.954ZM253.954 63.6886V61.6886H251.954V63.6886H253.954ZM286.503 63.6886H288.503V61.6886H286.503V63.6886ZM286.503 72.8968H284.503V74.8968H286.503V72.8968ZM296.033 72.8968H298.033V70.8968H296.033V72.8968ZM296.033 87.4584V89.4584H298.033V87.4584H296.033ZM282.327 87.4584H280.327V89.4584H282.327V87.4584ZM282.327 78.3574H284.327V76.3574H282.327V78.3574ZM258.129 78.3574V76.3574H256.129V78.3574H258.129ZM258.129 91.2059H256.129V93.2059H258.129V91.2059ZM277.081 91.2059H279.081V89.2059H277.081V91.2059ZM277.081 105.661V107.661H279.081V105.661H277.081ZM258.129 105.661V103.661H256.129V105.661H258.129ZM258.129 118.616H256.129V120.616H258.129V118.616ZM282.327 118.616V120.616H284.327V118.616H282.327ZM282.327 109.408V107.408H280.327V109.408H282.327ZM296.033 109.408H298.033V107.408H296.033V109.408ZM296.033 124.077V126.077H298.033V124.077H296.033ZM286.503 124.077V122.077H284.503V124.077H286.503ZM286.503 133.178V135.178H288.503V133.178H286.503ZM253.954 133.178H255.954V124.077H253.954H251.954V133.178H253.954ZM253.954 124.077V122.077H244.531V124.077V126.077H253.954V124.077ZM244.531 124.077H246.531V72.8968H244.531H242.531V124.077H244.531ZM244.531 72.8968V74.8968H253.954V72.8968V70.8968H244.531V72.8968ZM253.954 72.8968H255.954V63.6886H253.954H251.954V72.8968H253.954ZM253.954 63.6886V65.6886H286.503V63.6886V61.6886H253.954V63.6886ZM286.503 63.6886H284.503V72.8968H286.503H288.503V63.6886H286.503ZM286.503 72.8968V74.8968H296.033V72.8968V70.8968H286.503V72.8968ZM296.033 72.8968H294.033V87.4584H296.033H298.033V72.8968H296.033ZM296.033 87.4584V85.4584H282.327V87.4584V89.4584H296.033V87.4584ZM282.327 87.4584H284.327V78.3574H282.327H280.327V87.4584H282.327ZM282.327 78.3574V76.3574H258.129V78.3574V80.3574H282.327V78.3574ZM258.129 78.3574H256.129V91.2059H258.129H260.129V78.3574H258.129ZM258.129 91.2059V93.2059H277.081V91.2059V89.2059H258.129V91.2059ZM277.081 91.2059H275.081V105.661H277.081H279.081V91.2059H277.081ZM277.081 105.661V103.661H258.129V105.661V107.661H277.081V105.661ZM258.129 105.661H256.129V118.616H258.129H260.129V105.661H258.129ZM258.129 118.616V120.616H282.327V118.616V116.616H258.129V118.616ZM282.327 118.616H284.327V109.408H282.327H280.327V118.616H282.327ZM282.327 109.408V111.408H296.033V109.408V107.408H282.327V109.408ZM296.033 109.408H294.033V124.077H296.033H298.033V109.408H296.033ZM296.033 124.077V122.077H286.503V124.077V126.077H296.033V124.077ZM286.503 124.077H284.503V133.178H286.503H288.503V124.077H286.503ZM286.503 133.178V131.178H253.954V133.178V135.178H286.503V133.178Z"
          fill="black"
          mask="url(#path-7-outside-4_1394_456)"
        />
      </g>
      <g filter="url(#filter4_d_1394_456)">
        <mask
          id="path-9-outside-5_1394_456"
          maskUnits="userSpaceOnUse"
          x="287.16"
          y="27"
          width="23"
          height="29"
          fill="black"
        >
          <rect fill="white" x="287.16" y="27" width="23" height="29" />
          <path d="M294.296 53.4584V44.2503H289.691V34.3998H294.296V29.6886H303.182V34.721V36.5412V38.7897H308.001V53.4584H294.296Z" />
        </mask>
        <path
          d="M294.296 53.4584V44.2503H289.691V34.3998H294.296V29.6886H303.182V34.721V36.5412V38.7897H308.001V53.4584H294.296Z"
          fill="#96FF43"
        />
        <path
          d="M294.296 53.4584H292.296V55.4584H294.296V53.4584ZM294.296 44.2503H296.296V42.2503H294.296V44.2503ZM289.691 44.2503H287.691V46.2503H289.691V44.2503ZM289.691 34.3998V32.3998H287.691V34.3998H289.691ZM294.296 34.3998V36.3998H296.296V34.3998H294.296ZM294.296 29.6886V27.6886H292.296V29.6886H294.296ZM303.182 29.6886H305.182V27.6886H303.182V29.6886ZM303.182 38.7897H301.182V40.7897H303.182V38.7897ZM308.001 38.7897H310.001V36.7897H308.001V38.7897ZM308.001 53.4584V55.4584H310.001V53.4584H308.001ZM294.296 53.4584H296.296V44.2503H294.296H292.296V53.4584H294.296ZM294.296 44.2503V42.2503H289.691V44.2503V46.2503H294.296V44.2503ZM289.691 44.2503H291.691V34.3998H289.691H287.691V44.2503H289.691ZM289.691 34.3998V36.3998H294.296V34.3998V32.3998H289.691V34.3998ZM294.296 34.3998H296.296V29.6886H294.296H292.296V34.3998H294.296ZM294.296 29.6886V31.6886H303.182V29.6886V27.6886H294.296V29.6886ZM303.182 29.6886H301.182V34.721H303.182H305.182V29.6886H303.182ZM303.182 34.721H301.182V36.5412H303.182H305.182V34.721H303.182ZM303.182 36.5412H301.182V38.7897H303.182H305.182V36.5412H303.182ZM303.182 38.7897V40.7897H308.001V38.7897V36.7897H303.182V38.7897ZM308.001 38.7897H306.001V53.4584H308.001H310.001V38.7897H308.001ZM308.001 53.4584V51.4584H294.296V53.4584V55.4584H308.001V53.4584Z"
          fill="black"
          mask="url(#path-9-outside-5_1394_456)"
        />
      </g>
      <g filter="url(#filter5_d_1394_456)">
        <mask
          id="path-11-outside-6_1394_456"
          maskUnits="userSpaceOnUse"
          x="308"
          y="62"
          width="65"
          height="85"
          fill="black"
        >
          <rect fill="white" x="308" y="62" width="65" height="85" />
          <path d="M310.552 144.362V64.015H348.187V74.6619H359.082V85.185H370.1V123.192H359.082V133.839H348.187V144.362H310.552ZM326.275 127.525H343.359V116.878H354.254V91.4988H343.359V80.9757H326.275V127.525Z" />
        </mask>
        <path
          d="M310.552 144.362V64.015H348.187V74.6619H359.082V85.185H370.1V123.192H359.082V133.839H348.187V144.362H310.552ZM326.275 127.525H343.359V116.878H354.254V91.4988H343.359V80.9757H326.275V127.525Z"
          fill="#96FF43"
        />
        <path
          d="M310.552 144.362H308.552V146.362H310.552V144.362ZM310.552 64.015V62.015H308.552V64.015H310.552ZM348.187 64.015H350.187V62.015H348.187V64.015ZM348.187 74.6619H346.187V76.6619H348.187V74.6619ZM359.082 74.6619H361.082V72.6619H359.082V74.6619ZM359.082 85.185H357.082V87.185H359.082V85.185ZM370.1 85.185H372.1V83.185H370.1V85.185ZM370.1 123.192V125.192H372.1V123.192H370.1ZM359.082 123.192V121.192H357.082V123.192H359.082ZM359.082 133.839V135.839H361.082V133.839H359.082ZM348.187 133.839V131.839H346.187V133.839H348.187ZM348.187 144.362V146.362H350.187V144.362H348.187ZM326.275 127.525H324.275V129.525H326.275V127.525ZM343.359 127.525V129.525H345.359V127.525H343.359ZM343.359 116.878V114.878H341.359V116.878H343.359ZM354.254 116.878V118.878H356.254V116.878H354.254ZM354.254 91.4988H356.254V89.4988H354.254V91.4988ZM343.359 91.4988H341.359V93.4988H343.359V91.4988ZM343.359 80.9757H345.359V78.9757H343.359V80.9757ZM326.275 80.9757V78.9757H324.275V80.9757H326.275ZM310.552 144.362H312.552V64.015H310.552H308.552V144.362H310.552ZM310.552 64.015V66.015H348.187V64.015V62.015H310.552V64.015ZM348.187 64.015H346.187V74.6619H348.187H350.187V64.015H348.187ZM348.187 74.6619V76.6619H359.082V74.6619V72.6619H348.187V74.6619ZM359.082 74.6619H357.082V85.185H359.082H361.082V74.6619H359.082ZM359.082 85.185V87.185H370.1V85.185V83.185H359.082V85.185ZM370.1 85.185H368.1V123.192H370.1H372.1V85.185H370.1ZM370.1 123.192V121.192H359.082V123.192V125.192H370.1V123.192ZM359.082 123.192H357.082V133.839H359.082H361.082V123.192H359.082ZM359.082 133.839V131.839H348.187V133.839V135.839H359.082V133.839ZM348.187 133.839H346.187V144.362H348.187H350.187V133.839H348.187ZM348.187 144.362V142.362H310.552V144.362V146.362H348.187V144.362ZM326.275 127.525V129.525H343.359V127.525V125.525H326.275V127.525ZM343.359 127.525H345.359V116.878H343.359H341.359V127.525H343.359ZM343.359 116.878V118.878H354.254V116.878V114.878H343.359V116.878ZM354.254 116.878H356.254V91.4988H354.254H352.254V116.878H354.254ZM354.254 91.4988V89.4988H343.359V91.4988V93.4988H354.254V91.4988ZM343.359 91.4988H345.359V80.9757H343.359H341.359V91.4988H343.359ZM343.359 80.9757V78.9757H326.275V80.9757V82.9757H343.359V80.9757ZM326.275 80.9757H324.275V127.525H326.275H328.275V80.9757H326.275Z"
          fill="black"
          mask="url(#path-11-outside-6_1394_456)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1394_456"
          x="5.55176"
          y="62.015"
          width="85.3369"
          height="93.3468"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="9" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1394_456"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1394_456"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_1394_456"
          x="101.531"
          y="61.6886"
          width="55.501"
          height="82.4891"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="9" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1394_456"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1394_456"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_1394_456"
          x="165.919"
          y="62.0928"
          width="67.751"
          height="75.9746"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="9" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1394_456"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1394_456"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_1394_456"
          x="242.531"
          y="61.6886"
          width="55.501"
          height="82.4891"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="9" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1394_456"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1394_456"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_1394_456"
          x="287.691"
          y="27.6886"
          width="22.3096"
          height="36.7698"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="9" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1394_456"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1394_456"
            result="shape"
          />
        </filter>
        <filter
          id="filter5_d_1394_456"
          x="308.552"
          y="62.015"
          width="63.5488"
          height="93.3468"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="9" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1394_456"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1394_456"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
